import { useEffect } from "react"
import useToast from "@kit/design/use-toast"
import ReactRB from "./api"

/**
 * Handles dispatching calls from ReactRB.flash to useToast.
 * The reason this is named "flash" is to match Rails naming. The purpose of
 * this feature is to support standard rails flash messages on React pages.
 *
 * TODO: remove useToast from react-rb and allow it to be configured from
 * outside.
 */
function useFlash() {
  const toast = useToast()
  useEffect(() => {
    const handler = ({ type, data }) => {
      switch (type) {
        case "flash": {
          toast(data)
        }
      }
    }
    ReactRB.subscribe(handler)
    return () => ReactRB.unsubscribe(handler)
  }, [toast])
}
export default useFlash
